import { Flex } from '@utilitywarehouse/hearth-react';
import { color } from '@utilitywarehouse/hearth-tokens/js';

import InnerContainer from '~/components/Layout/InnerContainer';
import SectionContainer from '~/components/Layout/SectionContainer';

import serviceAward from '../assets/2024-service-winner-primary.svg';
import valueAward from '../assets/2024-value-winner-primary.svg';
import trustpilot from '../assets/trustpilot.svg';

function Awards() {
  return (
    <SectionContainer
      backgroundColor={color.warmWhite[50]}
      paddingY={{
        mobile: '500',
        tablet: '600',
      }}
    >
      <InnerContainer>
        <Flex
          justifyContent="center"
          gap={{
            mobile: '200',
            tablet: '900',
          }}
          direction={{
            mobile: 'column',
            tablet: 'row',
          }}
          alignItems="center"
        >
          <Flex direction="column" alignItems="center">
            <img
              width={213}
              height={69}
              src={serviceAward}
              alt="2024 Which? Service Award Winner"
            />
          </Flex>
          <Flex direction="column" alignItems="center">
            <img
              width={213}
              height={69}
              src={valueAward}
              alt="2024 Which? Value Award Winner"
            />
          </Flex>
          <Flex direction="column" alignItems="center">
            <img
              width={138}
              height={69}
              src={trustpilot}
              alt="Rated Excellent on Trustpilot"
            />
          </Flex>
        </Flex>
      </InnerContainer>
    </SectionContainer>
  );
}

export default Awards;
